// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'a4587b8a';
